import React, { useCallback } from 'react';

import Switch from '@mui/material/Switch';

interface ToggleCellProps {
  value: boolean;
  updateUsers: (params: { username: string; value: boolean; groupName: string }) => void;
  username: string;
  groupName: string;
}

const ToggleCell: React.FC<ToggleCellProps> = ({ value, updateUsers, username, groupName }) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      updateUsers({ username, value: e.target.checked, groupName });
    },
    [updateUsers, username, groupName],
  );

  return <Switch checked={value} onChange={handleChange} />;
};

export default ToggleCell;
